export const cn = (...classes: any[]): string => {
  let className: string = "";
  for (let i = 0; i < classes.length; i++) {
    if (classes[i]) {
      if (i > 0) {
        className += ` ${classes[i]}`;
      } else {
        className += classes[i];
      }
    }
  }

  return className;
};
